import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6aa77e74&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa77e74')) {
      api.createRecord('6aa77e74', component.options)
    } else {
      api.reload('6aa77e74', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=6aa77e74&", function () {
      api.rerender('6aa77e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/List.vue"
export default component.exports